import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  constructor() { }


  getApiUrl(): string {
    return environment.apiUrl + "/api";
  }

  getApiUrlIntegrador(): string {
    return environment.apiUrl + "/integrador";
  }

  getWebApiUrlIntegrador(): string {
    return environment.apiUrl + "/webapi";
  }

  getApiUrlRoot(): string {
    return environment.apiUrl;
  }
}
